module.exports = __webpack_public_path__ + "assets/img/Structure_item5.ceb3a0ff.png";